import { render, staticRenderFns } from "./DeliverySlotForm.vue?vue&type=template&id=57a33b17&scoped=true"
import script from "./DeliverySlotForm.vue?vue&type=script&lang=js"
export * from "./DeliverySlotForm.vue?vue&type=script&lang=js"
import style0 from "./DeliverySlotForm.vue?vue&type=style&index=0&id=57a33b17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a33b17",
  null
  
)

export default component.exports